import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AddToBuyListModalSupplierFragmentDoc } from './AddToBuyListModalSupplier.generated'
import * as Types from './purchasePlus_graphql'

export const AdvancedPrLineMoreOptionLineFragmentDoc = gql`
  fragment AdvancedPrLineMoreOptionLine on RequisitionLine {
    product {
      id
    }
    supplier {
      ...AddToBuyListModalSupplier
    }
  }
  ${AddToBuyListModalSupplierFragmentDoc}
` as unknown as DocumentNode<Types.AdvancedPrLineMoreOptionLineFragment, unknown>
